import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    itemImageContainer: {
        position: 'absolute',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#2E2F31',
        borderColor: '#5C5C5D',
        borderStyle: 'solid',
        borderWidth: 1
    },
    lockedContent: {
        textAlign: 'center',
        color: Theme.primaryTextColor,
        marginHorizontal: 5
    },
    textWrapper: {
        flexDirection: 'row',
        margin: 10
    }
};

export default StyleSheet.create(baseStyles);
